// General
import "./global-settings.scss";
import { useState, useEffect } from "react";
// Redux
import { useSelector, useDispatch } from "react-redux";
import {
  updateCardBorderEnabled,
  updateCardBorderImage,
} from "../../../../redux/store/cardBorderStore";
// Material UI
import { Button, IconButton, FormControlLabel, Switch } from "@mui/material";
import UploadIcon from "@mui/icons-material/Upload";

const GlobalSettings = () => {
  // General variables
  const [imageData, setImageData] = useState(null);

  // Redux variables
  const cardBorderEnabled = useSelector(
    (state) => state.cardBorder.cardBorderEnabled
  );
  const dispatch = useDispatch();

  // Event Handlers | Button
  const onFilePicker = async (event) => {
    const file = event.target.files[0];

    if (file !== undefined) {
      try {
        const imageData = await readFile(file);
        setImageData((prevState) => ({
          ...prevState,
          image: imageData,
          file: file,
        }));
        dispatch(updateCardBorderImage(imageData));
      } catch (error) {
        console.log(error);
      }
    }
  };

  // Event Handlers | MUI Switch
  const onShowProfileBorder = () => {
    dispatch(updateCardBorderEnabled(!cardBorderEnabled));
  };

  // Utility Functions
  const readFile = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        resolve(event.target.result);
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsDataURL(file);
    });
  };

  return (
    <div id="user-border-global-settings-subcomponent">
      <div className="global-settings-label">Global Settings </div>

      <div className="user-border-content">
        <div className="user-border-preview-container">
          <div className="user-border-preview-label-container">
            <IconButton
              className="profile-img-button"
              disableRipple
              component="label"
            >
              <input
                hidden
                accept="image/*"
                type="file"
                onChange={onFilePicker}
              />
              <UploadIcon />
            </IconButton>

            <div className="user-border-preview-label">Preview</div>
          </div>

          <div className="user-border-preview-image-container">
            <img className="user-border-preview" src={imageData?.image} />
          </div>
        </div>

        <div className="user-border-settings-container">
          <div>
            Note: profile photo is scaled down to 95% when there is a card
            border
          </div>

          <FormControlLabel
            control={
              <Switch
                checked={cardBorderEnabled}
                onChange={onShowProfileBorder}
              />
            }
            label="Enable"
          />
        </div>
      </div>
    </div>
  );
};

export default GlobalSettings;
